export const SidebarStyle = {
  WIDTH: 300,
  COLLAPSED_WIDTH: 78,
  ICON_CENTERING_RANGE: 26,
  EDGE_PADDING: 12,
  ITEM_HEIGHT: 46,
  ICON_SLOT: 40,
  NAV_ROW_HEIGHT: 54,
  NAV_ROW_INSET: 12,
  NAV_ICON_HEIGHT: 20,
  HOVER_EXPAND_DELAY_MILLIS: 120,

  Brand: {
    ICON_SIZE: 56,
    RAIL_ICON_SIZE: 54,
    RAIL_INSET: 12,
    INSET: 16,
    WORDMARK_HEIGHT: 20,
    WORDMARK_ASPECT: 5.43,
    VISION_LOCKUP_ASPECT: 2.95,
  },

  Locations: {
    RAIL_TILE_COUNT: 3,
  },

  Account: {
    PFP_SIZE: 48,
    PFP_INSET: 4,
    INSET: 16,
  },

  Menu: {
    ANCHOR_GAP: 8,
  },

  Foot: {
    STORAGE_BAR_HEIGHT: 8,
    PLAN_BAR_HEIGHT: 6,
    MIN_FILL_PERCENT: 0.5,
    BOLT_HEIGHT: 20,
  },
};

export function sidebarGeometry({ contentWidth, rail }) {
  const centeringProgress = Math.min(
    Math.max(
      (SidebarStyle.COLLAPSED_WIDTH + SidebarStyle.ICON_CENTERING_RANGE - contentWidth) /
        SidebarStyle.ICON_CENTERING_RANGE,
      0,
    ),
    1,
  );

  const iconOffset =
    ((contentWidth - SidebarStyle.EDGE_PADDING * 2 - SidebarStyle.ICON_SLOT) / 2) * centeringProgress;

  return { contentWidth, rail, centeringProgress, iconOffset };
}

export function iconSlotOffset(geometry, slotWidth) {
  return (
    geometry.iconOffset - ((slotWidth - SidebarStyle.ICON_SLOT) / 2) * geometry.centeringProgress
  );
}

export function usageLevel(percent) {
  if (percent >= 90) return 'critical';
  if (percent >= 70) return 'warning';
  return 'fine';
}

export function usagePercentage(used, limit) {
  if (!(limit > 0)) return 0;
  return Math.min((used / limit) * 100, 100);
}
